import { useEffect, useState } from "react";
import { ShieldAlert } from "lucide-react";
import { setCriticalHandler } from "../../lib/api";

export default function CriticalPasswordGate() {
  const [pending, setPending] = useState(null);
  const [pwd, setPwd] = useState("");

  useEffect(() => {
    const factory = (wasWrong = false) => new Promise((resolve, reject) => setPending({ resolve, reject, wasWrong }));
    setCriticalHandler(factory);
    return () => setCriticalHandler(null);
  }, []);

  if (!pending) return null;

  const close = (val) => {
    const p = pending;
    setPending(null);
    setPwd("");
    if (val) p.resolve(val);
    else p.reject(new Error("iptal"));
  };

  return (
    <div data-testid="critical-password-modal" className="fixed inset-0 z-[100] bg-black/50 flex items-center justify-center p-4" onClick={() => close(null)}>
      <div className="bg-white rounded-2xl w-full max-w-sm p-6 shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-2.5 mb-1">
          <ShieldAlert className="w-5 h-5 text-terra" />
          <h3 className="font-serif text-lg text-stone-900">Kritik Şifre Gerekli</h3>
        </div>
        <p className="text-xs text-stone-500 mb-4">Bu silme işlemi kritik işlemdir. Devam etmek için yönetim kritik şifresini girin.</p>
        {pending.wasWrong && (
          <p data-testid="critical-wrong-msg" className="text-xs font-semibold text-terra bg-red-50 border border-red-200 rounded-lg px-3 py-2 mb-3">Kritik şifre hatalı — lütfen tekrar deneyin.</p>
        )}
        <form onSubmit={(e) => { e.preventDefault(); if (pwd) close(pwd); }}>
          <input data-testid="critical-password-input" type="password" autoFocus autoComplete="off"
            className="w-full h-11 px-4 rounded-xl border border-stone-200 bg-stone-50 text-sm focus:outline-none focus:ring-2 focus:ring-terra/30 placeholder:text-stone-300"
            placeholder="Kritik şifre" value={pwd} onChange={(e) => setPwd(e.target.value)} />
          <div className="flex gap-2 mt-4">
            <button type="button" data-testid="critical-password-cancel" onClick={() => close(null)} className="flex-1 py-2.5 rounded-xl border border-stone-300 text-sm font-semibold text-stone-600 hover:bg-stone-50 transition-colors">Vazgeç</button>
            <button type="submit" data-testid="critical-password-confirm" className="flex-1 py-2.5 rounded-xl bg-terra hover:bg-terra-dark text-white text-sm font-semibold transition-colors">Onayla ve Sil</button>
          </div>
        </form>
      </div>
    </div>
  );
}
